<div class="notification">
  <g99-icon-btn
    [icon]="notificationIcon"
    [height]="iconSize"
    [width]="iconSize"
    [padding]="0"
    [backgroundColor]="'transparent'"
    [color]="'#ffffff'"
    [colorStrategy]="'both'"
    [isLoading]="false"
    [isDisabled]="false"
    (iconClick)="onClick()"
  />

  @if (hasUnread) {
    <span class="notification-dot" aria-hidden="true"></span>
  }
</div>
